import React, { Component } from "react";
import { Link } from "react-router-dom";
import { clearFilters } from "utils/localStorageServices";

const menuConfig = [
  { title: "Users", link: "/telegram/settings/users", page: "telegram-mini-app-users" },
  {
    title: "Analytics",
    link: "/telegram/settings/analytics/stats",
    page: "telegram-mini-app-analytics",
    submenu: [
      { title: "Stats", link: "/telegram/settings/analytics/stats", page: "telegram-mini-app-analytics-stats" },
      {
        title: "Retention",
        link: "/telegram/settings/analytics/retention",
        page: "telegram-mini-app-analytics-retention",
      },
    ],
  },
  {
    title: "BG Games",
    link: "/burn-ghost-games",
    page: "bgGames",
  },
  {
    title: "Battle Game",
    link: "/telegram/settings/battle-game/games",
    page: "telegram-mini-app-battleGame",
    submenu: [
      { title: "Games", link: "/telegram/settings/battle-game/games", page: "telegram-mini-app-battleGame-games" },
      { title: "Stages", link: "/telegram/settings/battle-game/stages", page: "telegram-mini-app-battleGame-stages" },
      {
        title: "Status Effects",
        link: "/telegram/settings/battle-game/status-effects",
        page: "telegram-mini-app-battleGame-status-effects",
      },
      {
        title: "Rewards",
        link: "/telegram/settings/battle-game/rewards",
        page: "telegram-mini-app-battleGame-rewards",
      },
      {
        title: "Enemies",
        link: "/telegram/settings/battle-game/enemies",
        page: "telegram-mini-app-battleGame-enemies",
      },
      { title: "Gears", link: "/telegram/settings/battle-game/gears", page: "telegram-mini-app-battleGame-gears" },
      {
        title: "Gears Subtype",
        link: "/telegram/settings/battle-game/gears-subtype",
        page: "telegram-mini-app-battleGame-subtype",
      },
      {
        title: "Game Images",
        link: "/telegram/settings/battle-game/images",
        page: "telegram-mini-app-battleGame-game-images",
      },
    ],
  },
  {
    title: "Player vs Player",
    link: "/telegram/settings/player-vs-player/contest",
    page: "telegram-mini-app-player-vs-player",
    submenu: [
      {
        title: "Contests",
        link: "/telegram/settings/player-vs-player/contest",
        page: "telegram-mini-app-player-vs-player-contest",
      },
      {
        title: "PVP Games",
        link: "/telegram/settings/player-vs-player/games",
        page: "telegram-mini-app-player-vs-player-games",
      },
    ],
  },
  { title: "Games", link: "/telegram/settings/games", page: "telegram-mini-app-games" },
  {
    title: "Luck Games",
    link: "/telegram/settings/zrun/",
    page: "telegram-mini-app-luckGame",
    submenu: [
      { title: "Zed Run", link: "/telegram/settings/zrun/", page: "telegram-mini-app-luckGame-zrun" },
      { title: "Cowitzer", link: "/telegram/settings/cowitzer/", page: "telegram-mini-app-luckGame-cowitzer" },
      {
        title: "Robot Racer",
        link: "/telegram/settings/robot-racer/",
        page: "telegram-mini-app-luckGame-robot-racer",
      },
    ],
  },
  {
    title: "Sweepstakes",
    link: "/telegram/settings/sweepstakes/",
    page: "telegram-mini-app-sweepstake",
    submenu: [
      {
        title: "Prizes Templates",
        link: "/telegram/settings/sweepstakes/prizes",
        page: "telegram-mini-app-sweepstake-prizes",
      },
      {
        title: "Sweepstakes Templates",
        link: "/telegram/settings/sweepstakes/templates",
        page: "telegram-mini-app-sweepstake-template",
      },
      {
        title: "Active",
        link: "/telegram/settings/sweepstakes/?status=active",
        page: "telegram-mini-app-sweepstake-active",
      },
      {
        title: "Completed",
        link: "/telegram/settings/sweepstakes/?status=ended",
        page: "telegram-mini-app-sweepstake-ended",
      },
      {
        title: "Scheduled",
        link: "/telegram/settings/sweepstakes/?status=scheduled",
        page: "telegram-mini-app-sweepstake-scheduled",
      },
      {
        title: "Canceled",
        link: "/telegram/settings/sweepstakes/?status=cancelled",
        page: "telegram-mini-app-sweepstake-cancelled",
      },
      { title: "All", link: "/telegram/settings/sweepstakes/", page: "telegram-mini-app-sweepstake-all" },
    ],
  },
  {
    title: "Daily Tournament",
    link: "/telegram/settings/daily-tournament",
    page: "telegram-mini-app-daily-tournament",
  },
  { title: "Team Play Challenges", link: "/telegram/settings/team-play", page: "telegram-mini-app-team-play" },
  {
    title: "Withdrawal Requests",
    link: "/telegram/settings/usdtWithdrawal",
    page: "telegram-mini-app-usdt-withdrawal",
  },

  {
    title: "Settings",
    link: "/telegram/settings/spinner/",
    page: "telegram-mini-app-settings",
    submenu: [
      {
        title: "Misc Settings",
        link: "/telegram/settings/misc-settings",
        page: "telegram-mini-app-settings-misc",
      },
      {
        title: "Spinner Rewards",
        link: "/telegram/settings/spinner",
        page: "telegram-mini-app-settings-spinner-rewards",
      },
      {
        title: "Verisoul Authentication Stats",
        link: "/telegram/settings/verisoul",
        page: "telegram-mini-app-settings-verisoul-authentication-stats",
      },
      {
        title: "Verisoul Linked Accounts",
        link: "/telegram/settings/verisoul-linked-account",
        page: "telegram-mini-app-settings-verisoul-linked-accounts",
      },
      {
        title: "Notifications",
        link: "/telegram/settings/notifications",
        page: "telegram-mini-app-settings-notifications",
      },
      { title: "Quests", link: "/telegram/settings/quests", page: "telegram-mini-app-settings-quests" },
      { title: "Ads", link: "/telegram/settings/ads", page: "telegram-mini-app-settings-ads" },
      { title: "Spin Packs", link: "/telegram/settings/spin-packs", page: "telegram-mini-app-settings-spin-packs" },
      {
        title: "Player Challenges",
        link: "/telegram/settings/challenges",
        page: "telegram-mini-app-settings-player-challenges",
      },
    ],
  },
  {
    title: "Website",
    link: "/users",
    page: "website",
    submenu: [
      {
        title: "Dashboard",
        link: "/dashboard/zed-run",
        page: "website-dashboard",
        submenu: [
          { title: "Zed Run", link: "/dashboard/zed-run", page: "website-dashboard-zrun" },
          { title: "Robot Racer", link: "/dashboard/robot-racer", page: "website-dashboard-robot-racer" },
          { title: "Cowitzer", link: "/dashboard/cowitzer", page: "website-dashboard-cowitzer" },
          { title: "Loot Box", link: "/dashboard/lootbox", page: "website-dashboard-loot-box" },
          {
            title: "Verisoul Authentication Stats",
            link: "/dashboard/verisoul",
            page: "website-dashboard-verisoul-authentication-stats",
          },
          {
            title: "Verisoul Linked Accounts",
            link: "/dashboard/verisoul-linked-account",
            page: "website-dashboard-verisoul-linked-accounts",
          },
          { title: "Referrals", link: "/dashboard/referrals", page: "website-dashboard-referrals" },
        ],
      },

      {
        title: "Games Played",
        link: "/games?amountType=1",
        page: "website-games",
        submenu: [
          { title: "Arcade Games", link: "/games?amountType=1", page: "website-games-arcade-games" },
          { title: "Loot Bucks Games", link: "/games?amountType=3", page: "website-games-loot-bucks-games" },
        ],
      },
      {
        title: "Contests",
        link: "/contests",
        page: "website-contests",
      },
      {
        title: "Users",
        link: "/users",
        page: "website-users",
      },
      {
        title: "Contest Winners",
        link: "/contest-winners?status=open",
        page: "website-winners",
        submenu: [
          { title: "Action Needed", link: "/contest-winners?status=open", page: "website-action-needed" },
          { title: "Closed", link: "/contest-winners?status=closed", page: "website-closed" },
        ],
      },
      {
        title: "Loot Boxes",
        link: "/lootbox",
        page: "website-lootbox",
      },
      {
        title: "Sweepstakes",
        link: "/sweepstakes/contracts",
        page: "website-sweepstakes",
        submenu: [
          { title: "Contracts", link: "/sweepstakes/contracts", page: "website-sweepstakes-contracts" },
          {
            title: "Instances Active/Paused",
            link: "/sweepstakes/instances?status=1",
            page: "website-sweepstakes-instances-active",
          },
          {
            title: "Instances Action Needed",
            link: "/sweepstakes/instances?status=2",
            page: "website-sweepstakes-instances-action-needed",
          },
          {
            title: "Instances Completed",
            link: "/sweepstakes/instances?status=3",
            page: "website-sweepstakes-instances-completed",
          },
          {
            title: "Instances Canceled",
            link: "/sweepstakes/instances?status=4",
            page: "website-sweepstakes-instances-canceled",
          },
          { title: "Currency", link: "/sweepstakes/currencies", page: "website-sweepstakes-currency" },
        ],
      },
      {
        title: "Settings",
        link: "/settings/packages",
        page: "website-settings",
        submenu: [
          { title: "Packages", link: "/settings/packages", page: "website-settings" },
          { title: "Custom Slides", link: "/custom-sliders", page: "website-settings" },
          { title: "Blockchain Network", link: "/settings/blockchain-networks", page: "website-settings" },
          { title: "Newsletter Subscribers", link: "/newsletter-subscribers", page: "website-settings" },
          { title: "Waiting List", link: "/wait-list", page: "website-settings" },
          { title: "Geolocation", link: "/geolocation", page: "website-settings" },
          { title: "Misc Settings", link: "/settings/misc-settings", page: "website-settings" },
          { title: "How It Works Template", link: "/how-it-works-template", page: "website-settings" },
          { title: "Contest Templates", link: "/settings/contest-templates", page: "website-settings" },
          {
            title: "Sweepstakes Templates",
            link: "/settings/sweepstakes-templates",
            page: "website-settings",
          },
          { title: "Coin Balance Report", link: "/settings/coin-balance-report", page: "website-settings" },
          { title: "Weekly Leaderboard", link: "/settings/weekly-leaderboard", page: "website-settings" },
          {
            title: "Ticket Redemption Requests",
            link: "/settings/ticket-redemption-requests",
            page: "website-settings",
          },
          { title: "Maintenance Mode", link: "/maintenance", page: "website-settings" },
        ],
      },
    ],
  },
];

class SideBar extends Component {
  componentDidUpdate = () => {
    const { page } = this.props;
    if (page !== "games") {
      clearFilters("paid-games");
    }
  };

  renderMenu = (menu) => {
    const { page } = this.props;
    console.log(page);
    return (
      <li className={`menu-item has-menu ${page?.includes(menu.page) && "active"}`}>
        <Link to={menu.link}>
          {menu.title}
          <span className="angle-arrow">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 3L11 8L6 13" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
        </Link>
        {menu.submenu && (
          <ul className="sidebar-submenu">
            {menu.submenu.map((submenu) => (
              <li className={`sidebar-submenu-item ${page?.includes(submenu.page) && "active"}`}>
                <Link to={submenu.link}>
                  {submenu.title}
                  {submenu?.submenu && (
                    <span className="angle-arrow">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 3L11 8L6 13" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                  )}
                </Link>
                {submenu.submenu && (
                  <ul className="level-three">
                    {submenu.submenu.map((child) => (
                      <li className={`child-item ${page === child.page && "active"}`}>
                        <Link to={child.link}>{child.title}</Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        )}
      </li>
    );
  };

  render() {
    return (
      <div className="page-sidebar">
        <div className="page-sidebar-inside hide-scrollbar">
          <ul className="menu-list">{menuConfig.map((menu) => this.renderMenu(menu))}</ul>
        </div>
      </div>
    );
  }
}

export default SideBar;
